import {resourceHasScheduleConflict} from './resource-schedule-conflict'
import type {DispatchTimelineData, UnassignedJob} from './types'

/**
 * True when the asset is already on another board job whose calendar days
 * overlap the draft job. The draft job itself is ignored so reassignment works.
 */
export function equipmentHasScheduleConflict(
    resourceId: string,
    draftJob: UnassignedJob,
    data: DispatchTimelineData,
): boolean {
    return resourceHasScheduleConflict(resourceId, draftJob, data)
}
